import React, { Component } from "react"
import CreateCoupons from "../../components/CreateCoupons"
import CouponsManagement from "../../components/CouponsManagement"

export default class AppManaged extends Component {
    constructor(props) {
        super(props)
        this.state = {
            check: 0,
        }
    }
    render() {
        const { check } = this.state
        return (
            <div>
                <div className="sts-header">
                    <div
                        className={check == 0 ? "sts-item active" : "sts-item"}
                        onClick={() => this.setState({ check: 0 })}
                    >
                        Create coupons
                    </div>
                    <div
                        className={check == 1 ? "sts-item active" : "sts-item"}
                        onClick={() => this.setState({ check: 1 })}
                    >
                        Coupons management
                    </div>
                </div>
                <div className="sts-body">{check == 0 ? <CreateCoupons /> : ""}</div>
                <div className="sts-body">{check == 1 ? <CouponsManagement /> : ""}</div>
            </div>
        )
    }
}
